import { formatPhoneDisplay } from "@/lib/phone-format";

/**
 * PO-speilet lager hovedkontakten «Kontaktperson» når PowerOffice har e-post
 * eller telefon, men ikke navn (migrasjon crm_customer_contacts). Det navnet
 * skal aldri vises som om det var en person.
 */
export const PLACEHOLDER_CONTACT_NAME = "Kontaktperson";

export function isPlaceholderContactName(name: string | null | undefined): boolean {
  return !name?.trim() || name.trim().toLowerCase() === PLACEHOLDER_CONTACT_NAME.toLowerCase();
}

export interface ContactLabel {
  /** Navn, eller e-post/telefon når navnet mangler. */
  primary: string;
  /** Tittel, eller «uten navn» når vi viser e-post/telefon. */
  secondary: string | null;
}

/** Hva vi viser for en kontakt: navnet, ellers e-post, ellers telefon. Null når det ikke finnes noe. */
export function contactLabel(c: {
  name?: string | null;
  title?: string | null;
  email?: string | null;
  phone?: string | null;
}): ContactLabel | null {
  if (!isPlaceholderContactName(c.name)) return { primary: c.name!.trim(), secondary: c.title?.trim() || null };
  if (c.email?.trim()) return { primary: c.email.trim(), secondary: "uten navn" };
  if (c.phone?.trim()) return { primary: formatPhoneDisplay(c.phone), secondary: "uten navn" };
  return null;
}
